import React, { useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "../App";
import { Capacitor } from '@capacitor/core';

const ProtectedRoute = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const isMobile = window.innerWidth <= 768 || Capacitor.isNativePlatform();

  useEffect(() => {
    if (!loading && !user) {
      navigate("/demo");
    }
  }, [user, loading, navigate, isMobile]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return <Outlet />;
};

export default ProtectedRoute;